module.exports = __webpack_public_path__ + "img/ThorntonTherapeutic.caa80f7f.jpg";